import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DisplaySymbolModule} from '../../../../../../../../components/display-symbol';
import {WHeaderTitlePartSymbolComponent} from './w-header-title-part-symbol.component';

@NgModule({
    imports: [
        CommonModule,
        DisplaySymbolModule
    ],
    declarations:    [
        WHeaderTitlePartSymbolComponent
    ],
    exports:         [
        WHeaderTitlePartSymbolComponent
    ]
})
export class WHeaderTitlePartSymbolModule {}
